import React, { useEffect } from "react";
import Apps from "../components/Apps/Apps";
import Landing from "../components/Landing/Landing";
import AOS from 'aos';
import "aos/dist/aos.css";
import Layout from "../components/Layout/Layout";

function Home() {
  useEffect(() => {
    AOS.init();
  }, []);

  return <Layout>
    <Landing />
    <Apps />
  </Layout>;
}

export default Home